import React from 'react';
import './App.css';
import ChatWindow from './components/ChatWindow';

function App() {
  return (
    <div className="App">
      <ChatWindow />
    </div>
  );
}

export default App;
